import { useCallback } from "react";
import { useApiBase } from "../../base/api-base";
import { ETypeDomain } from "../../../../config/types";
import { RequestAutorizacaoAprovacaoReprovacao } from "../../../../views/pages/private/autorizacao-page/model/autorizacao.model";

export const useAprovarAutorizacoes = () => {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const aprovarAutorizacoes = useCallback(
    (listaAutorizacaoId: Array<string>) => {
      var listaRequest = new Array<RequestAutorizacaoAprovacaoReprovacao>();
      listaAutorizacaoId.forEach(autorizacaoId => {
        listaRequest.push(new RequestAutorizacaoAprovacaoReprovacao(
          autorizacaoId,
          true
        ))
      })
      return invocarApi({
        url: `OperacaoPendente/autorizar-reprovar-lista`,
        method: "PUT",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(listaRequest),
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    aprovarAutorizacoes,
  };
}

export const useAprovarAutorizacao = () => {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const aprovarAutorizacao = useCallback(
    (operacaoPendenteId: string, autorizado: boolean = true) => {
      return invocarApi({
        url: `OperacaoPendente/autorizar-reprovar/${operacaoPendenteId}/${autorizado}`,
        method: "PUT",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    aprovarAutorizacao,
  };
}